// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"9a461705","787":"5d265ca6"}[chunkId] + ".chunk.js";
};